// extracted by mini-css-extract-plugin
export default {"VerifiedIcon":"MarketplaceItem-module__VerifiedIcon--Q9gte","Label":"MarketplaceItem-module__Label--PE0OA"};